<template>
  <div class="ReportFilterBarSubType">
    <div class="container-fluid">
      <div class="row vertical-align margin-Top-2Perc">
        <div class="col-md-5 col-lg-5 text-align-right">Type</div>
        <div class="col-md-6 col-lg-6 padding-left-0px">
          <div class="col-md-5 col-lg-5 padding-left-0px">
            <select class="form-control" v-model="selectedSubTypeValue">
              <option value=0>Normal</option>
              <option value=1>Teachback</option>
            </select>
          </div>
          <div class="col-md-7 col-lg-7"></div> 
        </div>
        <div class="col-lg-1 col-md-1"></div>
      </div>
    </div>
  </div>    
</template>

<script>
export default {
  created: function () {},
  data: function () {
    return {
      selectedSubType: 0
    }
  },
  methods: {},
  components: {},
  computed: {
    selectedSubTypeValue: {
      get: function () {
        return this.selectedSubType
      },
      set: function (newValue) {
        this.selectedSubType = newValue
        this.$emit('selectedSubType', this.selectedSubType)
      }
    }
  },
  watch: {},
  name: 'ReportFilterBarSubType'
}
</script>

<style scoped>
.ReportFilterBarSubType {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right {
  text-align: right;
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.border-red{
  border: 1px solid red;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.padding-left-0px {
  padding-left:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/ReportFilterBarSubType.vue